import axios from "./axios";
import store from "../store";

export default {
  //new functions
  async getFinanceInfoClass(selectedStudentsSIDs, statementsDate) {
    if (selectedStudentsSIDs.length > 0) {
      const students = await axios.postDataWithToken(
        "/auth/get-finance-info-class",
        {
          selectedStudents: selectedStudentsSIDs,
          statementsDate,
        },
        localStorage.getItem("token")
      );

      return students;
    } else {
      return [];
    }
  },
  //end of new functions
  async getAllIncomeCategories() {
    const categories = await axios.getData(
      "/auth/get-all-income-categories",
      localStorage.getItem("token")
    );
    return categories;
  },
  async getAllExpensesCategories() {
    const categories = await axios.getData(
      "/auth/get-all-expenses-categories",
      localStorage.getItem("token")
    );
    return categories;
  },
  async getAllServiceProviders() {
    const categories = await axios.getData(
      "/auth/get-all-service-providers",
      localStorage.getItem("token")
    );
    return categories;
  },
  async getDashboardIncomesData(filter, emis) {
    const data = await axios.postDataWithToken(
      "/auth/get-dashboard-incomes-data",
      { filter, emis },
      localStorage.getItem("token")
    );
    return data;
  },
  stripCurrency(amount) {
    if (amount.includes("R")) {
      amount = amount.split("R")[1];
    } else if (amount.includes("r")) {
      amount = amount.split("r")[1];
    } else if (amount.includes("ZAR")) {
      amount = amount.split("ZAR")[1];
    } else if (amount.includes("zar")) {
      amount = amount.split("zar")[1];
    } else if (amount.includes("Zar")) {
      amount = amount.split("Zar")[1];
    }
    return amount;
  },
};
